import ivclass from '@invideoio/web-shared/Modules/IVClass';

import BreadcrumbItem from '@components/breadcrumbs/breadcrumb-item';
import { BreadcrumbItemType } from '../../types';
import { useContext } from 'react';
import { StateContext } from '@store/store';

interface BreadcrumbProps {
  breadcrumbItems: Array<BreadcrumbItemType>;
}

const BreadCrumb = ({ breadcrumbItems }: BreadcrumbProps) => {
  const globalState = useContext(StateContext);
  const { platform } = globalState;
  let start = 0;
  let showEllipse = false;
  if (platform === 'mobile' && breadcrumbItems.length > 3) {
    start = breadcrumbItems.length - 2;
    showEllipse = true;
  }
  return (
    <ul
      className={ivclass('iv-flex iv-gap-5')}
      itemScope
      itemType="https://schema.org/BreadcrumbList"
    >
      {showEllipse && (
        <BreadcrumbItem
          position="1"
          title="Go to Academy for Professional Quality Video Creation."
          url="/blog"
          name="..."
          isLast={false}
          key="blog"
        />
      )}
      {breadcrumbItems
        .slice(start, breadcrumbItems.length)
        .map((item, index) => (
          <BreadcrumbItem
            {...item}
            position={(showEllipse ? index + 2 : index + 1).toString()}
            isLast={
              showEllipse ? index === 1 : index === breadcrumbItems.length - 1
            }
            key={index}
          />
        ))}
    </ul>
  );
};

export default BreadCrumb;
